var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuickbooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "quickbooks_svg__a",
    d: "M0 .033h48.967v48.966H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "quickbooks_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quickbooks_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.967 24.516c0 13.522-10.962 24.483-24.483 24.483C10.96 49-.001 38.038-.001 24.516S10.961.033 24.484.033c13.521 0 24.483 10.961 24.483 24.483",
    fill: "#2CA01C",
    mask: "url(#quickbooks_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-3.374V26.395h-3.019c-3.437 0-6.233 2.812-6.233 6.269 0 3.456 2.796 6.268 6.233 6.268h.878v3.395h-.878c-5.298 0-9.607-4.335-9.607-9.663S19.31 23 24.607 23H31v24zm9.394-5H34V18h3.375v20.606h3.02c3.435 0 6.23-2.812 6.23-6.269 0-3.457-2.795-6.268-6.23-6.268h-.88v-3.396h.88c5.296 0 9.605 4.336 9.605 9.664C50 37.665 45.69 42 40.394 42",
    fill: "#FFF"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0wIC4wMzNoNDguOTY3djQ4Ljk2NkgweiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4IDgpIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48cGF0aCBkPSJNNDguOTY3IDI0LjUxNmMwIDEzLjUyMi0xMC45NjIgMjQuNDgzLTI0LjQ4MyAyNC40ODNDMTAuOTYgNDktLjAwMSAzOC4wMzgtLjAwMSAyNC41MTZTMTAuOTYxLjAzMyAyNC40ODQuMDMzYzEzLjUyMSAwIDI0LjQ4MyAxMC45NjEgMjQuNDgzIDI0LjQ4MyIgZmlsbD0iIzJDQTAxQyIgbWFzaz0idXJsKCNiKSIvPjwvZz48cGF0aCBkPSJNMzEgNDdoLTMuMzc0VjI2LjM5NWgtMy4wMTljLTMuNDM3IDAtNi4yMzMgMi44MTItNi4yMzMgNi4yNjkgMCAzLjQ1NiAyLjc5NiA2LjI2OCA2LjIzMyA2LjI2OGguODc4djMuMzk1aC0uODc4Yy01LjI5OCAwLTkuNjA3LTQuMzM1LTkuNjA3LTkuNjYzUzE5LjMxIDIzIDI0LjYwNyAyM0gzMXYyNHptOS4zOTQtNUgzNFYxOGgzLjM3NXYyMC42MDZoMy4wMmMzLjQzNSAwIDYuMjMtMi44MTIgNi4yMy02LjI2OSAwLTMuNDU3LTIuNzk1LTYuMjY4LTYuMjMtNi4yNjhoLS44OHYtMy4zOTZoLjg4YzUuMjk2IDAgOS42MDUgNC4zMzYgOS42MDUgOS42NjRDNTAgMzcuNjY1IDQ1LjY5IDQyIDQwLjM5NCA0MiIgZmlsbD0iI0ZGRiIvPjwvZz48L3N2Zz4=";
export { SvgQuickbooks as ReactComponent };